<template>
    <div>
        <el-form :model="editItem" :rules="formRules" ref="editFormRef" label-width="150px">
            <el-row>
                <el-col :span="18">
                    <el-tooltip class="item" effect="dark" content="获取参数指令;锁机;解锁;复位;全部设置参数头;05;F1" placement="top-end">
                        <el-form-item label="获取参数指令：" prop="readprotocol">
                            <el-input v-model="editItem.readprotocol"></el-input>
                        </el-form-item>
                    </el-tooltip>
                </el-col>
                <el-col :span="3" :offset="1">
                    <el-select v-model="editItem.readprotocol">
                        <el-option
                                v-for="item in xieyi"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="22">
                    <el-form-item label="参数配置：" prop="struct">
                        <el-input type="textarea" v-model="editItem.struct"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="22">
                    <el-form-item label="简洁参数：" prop="pstructs">
                        <el-input type="textarea" v-model="editItem.pstructs"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="22">
                    <el-form-item label="控制配置：" prop="config">
                        <el-input type="textarea" v-model="editItem.config"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="校验类型：" prop="checkType">
                        <el-select v-model="editItem.checkType">
                            <el-option
                                    v-for="item in checkTypes"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="参数数据处理：" prop="processMode">
                        <el-input v-model="editItem.processMode"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="模板类型：" prop="mysign">
                        <el-select v-model="editItem.mysign">
                            <el-option
                                    v-for="item in mysigns"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="时间校正命令：" prop="checkprotocol">
                        <el-select filterable allow-create v-model="editItem.checkprotocol">
                            <el-option
                                    v-for="item in checkprotocols"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        item: {
            type: Object,
            default: function () {
                return {
                    checkType: '1',
                    checkprotocol: '',
                    config: '',
                    createTime: 0,
                    delFlag: true,
                    id: 0,
                    mysign: '0',
                    processMode: '',
                    productId: 0,
                    pstructs: '',
                    readprotocol: '01 03 1E 44 F8 4B;01 05;01 05;01 05;01 10 1E;05',
                    remark: '',
                    struct: '',
                    updateTime: 0
                }
            }
        }
    },
    data(){
        return {
            xieyi: [
                {name:'单片机',value:'01 03 1E 44 F8 4B;01 05;01 05;01 05;01 10 1E;05'},
                {name:'PLC',value:'01 03 00 45 00 5E D5 E7;01 05;01 05;01 05;01 10 00 45;05'},
                {name:'NET9B',value:'F1 23 00 00 01 52 50 90;01 05;01 05;01 05;01 06 00 00;05;F1'},
                {name:'NET9A+B',value:'01 23 00 0D 00 0A D5 C9;01 05;01 05;01 05;01 06 00 2A;05'}
            ],
            mysigns: [
                {name:'单独设置',value:'14'},
                {name:'全部设置',value:'0'}
            ],
            checkprotocols: [
                {name:'01 10 0e 02 hh mm',value:'01 10 0e 02 hh mm'},
                {name:'01 10 0e 03 hh mm ss',value:'01 10 0e 03 hh mm ss'},
                {name:'01 10 1e 03 hh mm ss',value:'01 10 1e 03 hh mm ss'},
                {name:'01 10 24 03 hh mm ss',value:'01 10 24 03 hh mm ss'},
                {name:'01 10 26 03 hh mm ss',value:'01 10 26 03 hh mm ss'},
                {name:'02 10 0e 03 hh mm ss',value:'02 10 0e 03 hh mm ss'},
                {name:'03 10 0e 03 hh mm ss',value:'03 10 0e 03 hh mm ss'},
                {name:'09 10 0e 03 hh mm ss',value:'09 10 0e 03 hh mm ss'}
            ],
            checkTypes: [
                {name:'CRC',value:'1'}
            ]
        }
    },
    methods: {
        async validateForm() {
            let p =await  new Promise((resolve, reject)=>{
                this.$refs.editFormRef.validate(async (valid)=>{
                    valid ? resolve() : reject()
                })
            })
            return p
        },
        checkStruct(rule, value,callback){
            if(value!=''&&value!='nothing'){
                if(!this.isJsonString(value)) return callback(new Error('请输入正确JSON格式'))
                let strunctsons=JSON.parse(value)
                let len=0
                let pstruct = ''
                for (let i = 0; i < strunctsons.length; i++) {
                    if(strunctsons[i].type=="A"||strunctsons[i].type=="B"||strunctsons[i].type=="C"||strunctsons[i].type=="BIT"){
                        len++
                    }else if(strunctsons[i].type=="D"){
                        len++
                        len++
                    }else if(strunctsons[i].type=="E"){
                        len++
                        len++
                    }
                }
                for (let i = 1; i <=len; i++) {
                    pstruct+=",a"+i
                }
                this.editItem.pstructs = pstruct.substring(1)
            }
            return callback()
        },
        checkSign(rule, value,callback){
            if(value!=''&&value!='nothing') {
                if (!this.isJsonString(this.editItem.struct)) return callback(new Error('请输入正确JSON格式'))
                let strunctsons = JSON.parse(this.editItem.struct)
                for (let i = 0; i < strunctsons.length; i++) {
                    // console.log(value==='14',strunctsons[i].protocol_head)
                    if(value==='14'&&(strunctsons[i].protocol_head===undefined||strunctsons[i].protocol_head==='undefined'||strunctsons[i].protocol_head==='')){
                        return callback(new Error(strunctsons[i].name+" 缺协议头!"))
                    }
                }
            }
            return callback()
        },
        isJsonString(str) {
            try {
                if (typeof JSON.parse(str) == 'object') {
                    return true
                }
            }catch {
                return false
            }
            return false
        }
    },
    computed: {
        formRules: function(){
            let arr= {}
            arr.readprotocol = [
                { required: true, message: '请输入参数指令', trigger: 'blur' }
            ]
            arr.struct = [
                /*{ required: true, message: '请配置参数结构', trigger: 'blur' },*/
                { validator: this.checkStruct, trigger: 'blur' }
            ]
            arr.mysign = [
                { required: true, message: '请选择模板类型', trigger: 'blur' },
                { validator: this.checkSign, trigger: 'change' }
            ]
            return arr
        },
        editItem: function (){
            return this.item
        }
    }
}
</script>

<style scoped>

</style>
